module.exports = __webpack_public_path__ + "img/i_plus_w.aac2da03.svg";